import { connectedStore } from '../../../store';
import site from '../../../site';
import view from '../../../view';
import globals from '../../../globals';
import mutationTypes from '../../constants/mutation-types';

const create = (action) => {
  const store = connectedStore.get();
  const state = store.getState();
  const activePageId = site.selectors.getActivePageId(state);
  const activePage = site.selectors.getPage(state, activePageId);
  const oldHTML = activePage.html;
  const { globalsToUpdate } = action.payload;

  let affectedGlobals = [];
  if (globalsToUpdate) {
    affectedGlobals = globalsToUpdate.map((globalToUpdate) => {
      const global = globals.selectors.getGlobal(state, globalToUpdate.id);
      return {
        id: globalToUpdate.id,
        oldHTML: global.html,
      };
    });
  }

  return {
    type: mutationTypes.HTML_MUTATION,
    oldHTML,
    affectedGlobals,
  };
};

const invert = (mutation) => {
  const { oldHTML, affectedGlobals } = mutation;
  const globalsToUpdate = affectedGlobals.map((global) => ({
    id: global.id,
    newHTML: global.oldHTML,
  }));

  return view.actions.changeHTML(oldHTML, globalsToUpdate);
};

export default {
  create,
  invert,
};
